import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import BrowserUtils from '../shared/utils/browser-utils';
import { LogRenegociacaoCartao } from '../shared/models/renegociacao-cartao-logger-service.model';
import { AutenticacaoService } from '../seguranca/autenticacao.service';
import { ApiService } from '../shared/api/api.service';

export type LogRenegociacaoCartaoData = Omit<LogRenegociacaoCartao, 'origem' | 'rastreabilidade' | 'token' | 'tokenParceiro'>

@Injectable({
  providedIn: 'root'
})
export class RenegociacaoCartaoLoggerService {

  constructor(
    private http: HttpClient,
    private autenticacaoService: AutenticacaoService,
    private apiService: ApiService
  ) { }

  async enviarLogRenegociacaoCartao(logRenegociacaoCartao: LogRenegociacaoCartaoData) {
    const path = this.apiService.getEndpoint({
      apiKey: 'cdc-portal-negociacao-cartao-bradesco',
      path: '/negociacao-cartao-bradesco/audit/negotiation-bradesco',
      oldBrowserFallbackPath: '/audit/negotiation-bradesco'
    })

    const dataToLog: LogRenegociacaoCartao = {
      ...logRenegociacaoCartao,
      origem: this.autenticacaoService.obterTipoAutenticacao(),
      rastreabilidade: this.autenticacaoService.obterHashRastreabilidade(),
      token: this.autenticacaoService.token,
      tokenParceiro: this.autenticacaoService.obterTokenParceiro(),
    };

    return this.http.post(path, dataToLog, {
      headers: {
        Authorization: `${this.autenticacaoService.token}`
      }
    }).toPromise();
  }

  get apiUrlService(): string {
    if (BrowserUtils.isOldFirefox()) {
      return `${environment.cdccorpApiURLService}`;
    }

    return `${environment.apiURLService}`;
  }
}
